import { UploadWorkflowFileStatusEnum } from "@flexidao/dto";

export const formatUploadWorkflowFileStatus = (status: UploadWorkflowFileStatusEnum): string => {
    switch (status) {
        case UploadWorkflowFileStatusEnum.PENDING_TO_PARSE:
            return "Parsing...";
        case UploadWorkflowFileStatusEnum.PARSE_FAILED:
            return "Parsing failed";
        case UploadWorkflowFileStatusEnum.TO_REVIEW:
            return "To validate";
        case UploadWorkflowFileStatusEnum.PENDING_TO_VALIDATE:
            return "Validating...";
        case UploadWorkflowFileStatusEnum.VALIDATION_FAILED:
            return "Validation failed";
        case UploadWorkflowFileStatusEnum.VALIDATED:
            return "To submit";
        case UploadWorkflowFileStatusEnum.PENDING_TO_SUBMIT:
            return "Submitting...";
        case UploadWorkflowFileStatusEnum.COMPLETED:
            return "Submitted";
        case UploadWorkflowFileStatusEnum.SUBMIT_FAILED:
            return "Submit failed";
        case UploadWorkflowFileStatusEnum.DELETED:
            return "Deleted";
    }
};
